/* eslint-disable react/prop-types */
import React from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Checkbox from '@mui/material/Checkbox'
import Box from '@mui/material/Box'
import Slider from '@mui/material/Slider'
import { Filter, Line, Preço, ContainerButton } from './styles'

export default function FilterProducts(props) {
  const marks = [
    {
      value: 100,
      label: 'R$100'
    },
    {
      value: 1900,
      label: 'R$1.900.00'
    }
  ]

  function valuetext(value) {
    return `${value}`
  }
  return (
    <Filter>
      <div>
        <legend>Filtrar os Resultados<AiOutlineClose  onClick={props.openFilter}  className="close" /></legend>
        <p>Bagagem</p>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="Voos com mala despachada" />
        </FormGroup>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="Voos sem mala despachada" />
        </FormGroup>
        <Line></Line>
        <Preço>
          <p>Preço</p>
          <Box sx={{ width: 270 }}>
            <Slider
              min={100}
              max={1900}
              aria-label="Always visible"
              defaultValue={80}
              getAriaValueText={valuetext}
              step={10}
              marks={marks}
              valueLabelDisplay="on"
            />
          </Box>
        </Preço>
        <Line></Line>
        <Preço>
          <p>Horário de ida</p>
          <Box sx={{ width: 270 }}>
            <Slider
              min={100}
              max={1900}
              aria-label="Always visible"
              defaultValue={80}
              getAriaValueText={valuetext}
              step={10}
              marks={marks}
              valueLabelDisplay="on"
            />
          </Box>
        </Preço>
        <Line></Line>
        <Preço>
          <p>Horário de volta</p>
          <Box sx={{ width: 270}}>
            <Slider
              min={100}
              max={1900}
              aria-label="Always visible"
              defaultValue={80}
              getAriaValueText={valuetext}
              step={10}
              marks={marks}
              valueLabelDisplay="on"
            />
          </Box>
        </Preço>
        <Line></Line>
        <Preço>
          <p>Duração do vôo</p>
          <Box sx={{ width: 270 }}>
            <Slider
              min={100}
              max={1900}
              aria-label="Always visible"
              defaultValue={80}
              getAriaValueText={valuetext}
              step={10}
              marks={marks}
              valueLabelDisplay="on"
            />
          </Box>
        </Preço>
        <Line></Line>
        <p>Número de paradas</p>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="{label}" />
        </FormGroup>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="{label}" />
        </FormGroup>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="{label}" />
        </FormGroup>
        <Line></Line>
        <p>Companhia aérea</p>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="{label}" />
        </FormGroup>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="{label}" />
        </FormGroup>
        <FormGroup>
          <FormControlLabel component="input" control={<Checkbox />} label="{label}" />
        </FormGroup>
        <ContainerButton>
          <button className="applyFIlter" type="button">APLICAR FILTRO</button>
          <button className="cleanFilter" type="reset">LIMPAR FILTRO</button>
        </ContainerButton>
      </div>
    </Filter>
  )
}
